import { makeStyles, Slider, withStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import settingsMethods from "../../services/settingsApi";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 300 + theme.spacing(3) * 2,
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const WiFiSlider = ({ dataValue, disabled }) => {
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const timeoutRef = useRef(null);

  const marks = [
    { value: 0, label: "0dB" },
    { value: 1, label: "0.25dB" },
    { value: 2, label: "0.5dB" },
    { value: 3, label: "1dB" },
    { value: 4, label: "2dB" },
    { value: 5, label: "4dB" },
    { value: 6, label: "8dB" },
    { value: 7, label: "16dB" },
    { value: 8, label: "31.75dB" },
  ];

  const AirbnbSlider = withStyles({
    root: {
      color: "#6bc4e2",
      height: 3,
      padding: "13px 0",
    },
    thumb: {
      height: 25,
      width: 25,
      backgroundColor: "#fff",
      border: "1px solid currentColor",
      marginTop: -12,
      marginLeft: -13,
      boxShadow: "#ebebeb 0 2px 2px",
      "&:focus, &:hover, &$active": {
        boxShadow: "#ccc 0 2px 3px 1px",
      },
    },
    active: {},
    track: {
      height: 3,
    },
    rail: {
      color: "#d8d8d8",
      opacity: 1,
      height: 3,
    },
  })(Slider);

  const valuetext = (value) => {
    const mark = marks.find((mark) => mark.value === value);
    return mark ? mark.label : `${value}`;
  };

  const updateBackend = async (sliderValue) => {
    setLoading(true);
    const updatedData = {
      type: "wifi_attenuation",
      device_id: sliderValue,
      wifi_attenuation: sliderValue,
    };
    try {
      await settingsMethods.updateSettings(updatedData);
      toast.success("Settings updated successfully!");
    } catch (error) {
      toast.error("Error while updating!");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      updateBackend(newValue);
    }, 2000);
  };

  useEffect(() => {
    if (dataValue >= 0 && dataValue <= 8) {
      setValue(dataValue);
    }
  }, [dataValue]);

  return (
    <div className="col-md-8 col-sm-12 custom-slider1">
      <label style={{ color: "white", fontSize: 12 }}>
        Wifi Signal Strength - ({valuetext(value)})
        <span className="text-danger font-italic">
          {disabled ? " - Turn off ghost mode to modify" : ""}
        </span>
      </label>
      <div className="d-flex">
        <AirbnbSlider
          value={value}
          onChange={handleChange}
          getAriaValueText={valuetext}
          valueLabelDisplay="auto"
          valueLabelFormat={valuetext}
          marks={marks}
          step={1} // Step matches defined marks
          min={0}
          max={8}
          disabled={disabled}
        />
      </div>
      {loading && <p style={{ color: "white", fontSize: 12 }}>Updating...</p>}
    </div>
  );
};

export default WiFiSlider;
